import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";
import { option_colData } from "../../service/option";

export default function ModuleChartLine({
  cData,
  cOptions,
  lineKey,
  referenceKey = [],
}) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={cData} {...cOptions}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />

        {referenceKey.map((item, index) => (
          <ReferenceLine
            y={item.value}
            label={item.label ?? ""}
            stroke={item.color ?? "red"}
          />
        ))}

        {lineKey.map((item, index) => (
          <Line
            connectNulls
            type="monotone"
            dataKey={item.label}
            stroke={`#${option_colData[index]}`}
            // activeDot={{ r: 6 }}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
